import React, { FunctionComponent, useMemo } from 'react';
import { useCurrentBilikZones } from 'context/current-bilik-zones-context';
import SmsReceivedList from 'components/sms-received-list/sms-received-list';

const SmsReceivedPage: FunctionComponent = () => {
  const { currentBilikZones } = useCurrentBilikZones();

  const title: React.ReactElement = useMemo(
    () => (
      <>
        Demandes sms
        <small>
          {currentBilikZones
            ? currentBilikZones.map((zone) => zone.mainCityCode).join(', ')
            : 'Toutes les zones'}
        </small>
      </>
    ),
    [currentBilikZones],
  );

  return <SmsReceivedList title={title} />;
};

export default SmsReceivedPage;
